export default function otsoPanaloError(error, fallback) {
  const data = error && (error.data || error);
  const messages = data && data.messages;
  const candidates = [
    data && data.message,
    messages && messages.error,
    typeof messages === "string" ? messages : null,
    data && data.error,
    typeof data === "string" ? data : null,
  ];

  const message = candidates.find(
    (value) => typeof value === "string" && value.trim(),
  );

  return message || fallback;
}
